import type { EzStandalone } from 'interface/ezoic'

import { ensureEzQueue } from './ensureEzQueue'

/**
 * Queues a command to run when Ezoic is ready.
 * Always reads fresh window.ezstandalone to avoid stale closure issues.
 */
export const queueEzCommand = (callback: (ez: EzStandalone) => void): void => {
  const ez = ensureEzQueue()

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  ez.cmd!.push(() => {
    // Read fresh window.ezstandalone inside the callback
    const currentEz = (window as unknown as { ezstandalone?: EzStandalone }).ezstandalone
    if (!currentEz) return

    callback(currentEz)
  })
}
